export function batchByKey(callback) {
  var calls = {};
  return function (key) {
    if (!calls[key]) {
      window.setTimeout(function () {
        callback(key, calls[key]);
        delete calls[key];
      });
      calls[key] = [];
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    calls[key].push(args);
  };
}